<script>
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import {
  BaseAffiliateLinkElementMixin,
} from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/base-affiliate-link-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "ProductLinkCoverImage",
  extends: BaseImageElement,
  elementPanelSettings: {
    displayName: "Cover Image",
    displayIcon: "image",
    elementType: "element",
    elementGroup: "Product",
  },
  mixins: [BaseAffiliateLinkElementMixin, FallbackImageElementMixin],
  computed: {
    imageHref() {
      return this.entity.affiliateLink;
    },
    imageSrc() {
      return this.entity.productImageUrl;
    },
  },
};
</script>
